import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { TooltipUtils } from '../tooltip/Tooltip'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import './CopyTextToClipboard.scss'

export const CopyTextToClipboard = ({
  text,
  tooltipCopied,
  tooltipClickToCopy,
  children,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  const [copied, setCopied] = useState(null)
  const [showCopyIcon, setShowCopyIcon] = useState(false)
  const iconRef = useRef(null)

  function showHideCopy(show) {
    setShowCopyIcon(show)
    setTimeout(function() {
      setCopied(false)
    }, 200)
  }

  function copyToClipBoard() {
    setCopied(true)
    setShowCopyIcon(false)
    TooltipUtils.hide(iconRef.current)
    setTimeout(function() {
      TooltipUtils.show(iconRef.current)
    }, 200)
  }

  return (
    <>
      {/* <Tooltip /> */}
      <div
        className={classnames('copy-to-clipboard-container', className)}
        data-mu-test={classnames('copytext-to-clipboard', dataAttributeTest)}
      >
        <div
          onMouseEnter={() => showHideCopy(true)}
          onMouseLeave={() => showHideCopy(false)}
        >
          <div className='copy-to-clipboard-children-container'>
            {children}

            <CopyToClipboard onCopy={() => copyToClipBoard(text)} text={text}>
              <span
                ref={iconRef}
                data-tip={!copied ? tooltipClickToCopy : tooltipCopied}
                className={classnames(
                  'animate-fade-in copy-to-clipboard-icon-container',
                  {
                    show: showCopyIcon,
                    'copy-to-clipboard-icon': !copied,
                    'copy-to-clipboard-icon-copied': copied
                  }
                )}
                data-mu-test='copy-to-clipboard-icon'
              />
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </>
  )
}

CopyTextToClipboard.defaultProps = {}

CopyTextToClipboard.propTypes = {
  text: PropTypes.string,
  tooltipCopied: PropTypes.string,
  tooltipClickToCopy: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
